var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('h5',{staticClass:"text-nowrap text-truncate",attrs:{"title":_vm.article.title},domProps:{"innerHTML":_vm._s(_vm.article.title)}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.article.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }